module.exports = __webpack_public_path__ + "img/mapImgSelected.a44278ed.png";